import React from 'react'

import Address from 'components/Lookups/Address'
import AddressMap from 'components/Map/AddressMap'

import {
  getValidatePostcode,
} from 'requesters/postcodes'

class AddressWithMap extends React.Component {
  state = {
    coords: {}
  }

  postcodeValidationSuccess = () => {
    this.setState({ errorMessage: null })
    this.props.postcodeValidationSuccess()
  }

  postcodeValidationFailure = () => {
    this.setState({ errorMessage: I18n.t('onboarding.loan_location.errors.postcode') })
    this.props.postcodeValidationFailure()
  }

  onChange = (addressData) => {
    const {
      locationAddress,
      locationSuburb,
      locationPostcode,
      locationState,
      coords,
    } = addressData

    // Set coordinates to render Map
    this.setState({coords})

    // Validate Postode and trigger events if necessary
    const {
      validateServicedPostcode,
      onChange,
    } = this.props

    if (validateServicedPostcode) {
      getValidatePostcode(locationPostcode, this.postcodeValidationSuccess, this.postcodeValidationFailure)
    }

    // trigger onChange event
    this.props.onChange(addressData)
  }

  render() {
    const {
      coords,
      errorMessage,
    } = this.state;

    const {
      label,
      size,
    } = this.props;

    return(
      <div>
        <Address
          label='Please enter your address'
          size={ size }
          onChange={ this.onChange }
          errorMessage={ errorMessage }
        />
        {
          (Object.keys(coords).length > 0) && (
            <AddressMap
              googleMapURL={ `https://maps.googleapis.com/maps/api/js?key=${gon.services.google_map_api_key}` }
              loadingElement={ <div style={{ height: `100%` }} /> }
              containerElement={ <div style={{ height: `400px` }} /> }
              mapElement={ <div style={{ height: `100%` }} /> }
              coords={ coords }
            />
          )
        }
      </div>
    )
  }
}

export default AddressWithMap;
